var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { AlertifyService } from '../../../../services/alertify.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { HubComponent } from '../../hub.component';
import { EventLocationFilterGroup, PlaceLocationFilterGroup } from './location.filter.settings.provider';
import { AccountApiService } from '../../../../services/account.api.service';
import { FormBuilder } from '@angular/forms';
import { ShowInfoModalComponent } from '../../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../show.info.modal/show.info.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { ToggleAndDataSourceStore } from '../../../../stores/hub.calendar.store';
var LocationFilterSettingsComponent = /** @class */ (function (_super) {
    __extends(LocationFilterSettingsComponent, _super);
    function LocationFilterSettingsComponent(formBuilder, hubApiService, parent, activatedRoute, alertify, accountApiService, toggleAndDataSourceStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.hubApiService = hubApiService;
        _this.parent = parent;
        _this.activatedRoute = activatedRoute;
        _this.alertify = alertify;
        _this.accountApiService = accountApiService;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.modalService = modalService;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.hubName = null;
        _this.clientPlaceGroups = [];
        _this.clientEventGroups = [];
        _this.selectedPlaceGroup = null;
        _this.selectedEventGroup = null;
        _this.placeCities = [];
        _this.placeIsCityLevelFilter = false;
        _this.eventCities = [];
        _this.eventIsCityLevelFilter = false;
        return _this;
    }
    LocationFilterSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.parent.location = 'Location Filters';
        this.form = this.formBuilder.group({
            tempTitle: [null, []],
        });
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            if (toggleCommand.toggle) {
                _this.toggles = toggleCommand.toggle;
            }
        });
        this.loadLocations();
    };
    LocationFilterSettingsComponent.prototype.loadLocations = function () {
        var _this = this;
        this.clientEventGroups = [];
        this.clientPlaceGroups = [];
        this.accountApiService.getCustomLocationFilterGroups(this.hubName)
            .subscribe(function (res) {
            if (res && res.customPlaceLocationFilterGroups) {
                _this.clientPlaceGroups = res.customPlaceLocationFilterGroups.placeGroups;
                _this.placeIsCityLevelFilter = res.customPlaceLocationFilterGroups.isCityLevelFilter;
            }
            if (res && res.customEventLocationFilterGroups) {
                _this.clientEventGroups = res.customEventLocationFilterGroups.eventGroups;
                _this.eventIsCityLevelFilter = res.customEventLocationFilterGroups.isCityLevelFilter;
            }
        });
        this.placeCities = [];
        this.hubApiService.getPlaceLocationFilters(this.hubName)
            .subscribe(function (localities) {
            if (localities && localities.length > 0) {
                localities.forEach(function (item) {
                    _this.placeCities.push(item.locality);
                });
            }
        });
        this.eventCities = [];
        this.hubApiService.getEventLocationFilters(this.hubName)
            .subscribe(function (localities) {
            if (localities && localities.length > 0) {
                localities.forEach(function (item) {
                    _this.eventCities.push(item.locality);
                });
            }
        });
    };
    Object.defineProperty(LocationFilterSettingsComponent.prototype, "isEventLocationFilterDisabled", {
        get: function () {
            return !this.toggles.eventLocationFilter || (!this.toggles.eventByGeolocation && !this.toggles.manualEvents);
        },
        enumerable: true,
        configurable: true
    });
    LocationFilterSettingsComponent.prototype.addPlaceGroup = function () {
        this.clientPlaceGroups.push(new PlaceLocationFilterGroup('New group'));
    };
    LocationFilterSettingsComponent.prototype.addEventGroup = function () {
        this.clientEventGroups.push(new EventLocationFilterGroup('New group'));
    };
    LocationFilterSettingsComponent.prototype.addCityToPlaceGroup = function ($event, city) {
        if (!this.selectedPlaceGroup)
            return;
        if ($event.checked) {
            if (!this.selectedPlaceGroup.cities.any(function (item) { return item === city; })) {
                this.selectedPlaceGroup.cities.push(city);
            }
        }
        else {
            this.selectedPlaceGroup.cities = this.selectedPlaceGroup.cities.filter(function (item) { return item !== city; });
        }
    };
    LocationFilterSettingsComponent.prototype.addCityToEventGroup = function ($event, city) {
        if (!this.selectedEventGroup)
            return;
        if ($event.checked) {
            if (!this.selectedEventGroup.cities.any(function (item) { return item === city; })) {
                this.selectedEventGroup.cities.push(city);
            }
        }
        else {
            this.selectedEventGroup.cities = this.selectedEventGroup.cities.filter(function (item) { return item !== city; });
        }
    };
    LocationFilterSettingsComponent.prototype.save = function (event) {
        var _this = this;
        console.log(this.clientPlaceGroups);
        if (this.clientPlaceGroups.any(function (item) { return !item.cities.length; })) {
            this.alertify.warning('Please select cities for all groups');
            event.immediateComplete();
            return;
        }
        this.accountApiService
            .setCustomPlaceGroups(this.hubName, this.clientPlaceGroups, this.placeIsCityLevelFilter)
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Set place groups for location filter');
        });
    };
    LocationFilterSettingsComponent.prototype.saveEvent = function (event) {
        var _this = this;
        console.log(this.clientEventGroups);
        if (this.clientEventGroups.any(function (item) { return !item.cities.length; })) {
            this.alertify.warning('Please select cities for all groups');
            event.immediateComplete();
            return;
        }
        this.accountApiService
            .setCustomEventGroups(this.hubName, this.clientEventGroups, this.eventIsCityLevelFilter)
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Set event groups for location filter');
            _this.loadLocations();
        });
    };
    LocationFilterSettingsComponent.prototype.enterEditMode = function (group) {
        group.tempTitle = group.title;
        group.isEditing = true;
    };
    LocationFilterSettingsComponent.prototype.removePlaceGroup = function (group) {
        this.clientPlaceGroups = this.clientPlaceGroups.filter(function (item) { return item !== group; });
    };
    LocationFilterSettingsComponent.prototype.removeEventGroup = function (group) {
        this.clientEventGroups = this.clientEventGroups.filter(function (item) { return item !== group; });
    };
    LocationFilterSettingsComponent.prototype.updateGroupTitle = function (group) {
        if (group.tempTitle) {
            group.title = group.tempTitle;
            group.isEditing = false;
        }
    };
    LocationFilterSettingsComponent.prototype.cancelGroupTitle = function (group) {
        group.tempTitle = "";
        group.isEditing = false;
    };
    LocationFilterSettingsComponent.prototype.selectPlaceGroup = function (group) {
        this.clientPlaceGroups.forEach(function (item) {
            item.isSelected = item === group;
        });
        this.selectedPlaceGroup = group;
    };
    LocationFilterSettingsComponent.prototype.selectEventGroup = function (group) {
        this.clientEventGroups.forEach(function (item) {
            item.isSelected = item === group;
        });
        this.selectedEventGroup = group;
    };
    LocationFilterSettingsComponent.prototype.isCityInGroup = function (city, group) {
        if (!group)
            return false;
        return group.cities.any(function (x) { return x === city; });
    };
    LocationFilterSettingsComponent.prototype.setUseGroupFilter = function () {
        var _this = this;
        this.accountApiService
            .setCustomPlaceUseGroupFilter(this.hubName, this.placeIsCityLevelFilter)
            .subscribe(function () {
            if (_this.placeIsCityLevelFilter) {
                _this.alertify.successfully('Set use group filter');
            }
            else {
                _this.alertify.successfully('Set use city filter');
            }
        });
    };
    LocationFilterSettingsComponent.prototype.showLocationWidgetUrl = function (group, type) {
        if (!group._id) {
            this.alertify.warning("Please save the changes first.");
            return;
        }
        var link = "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/" + type + "/location/group/" + group._id + "\" url-change=\"true\" version=\"V3\">\n        <app-root></app-root> \n        <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n    </div>";
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Place Location Widget URL', null, [], link, true),
                },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    return LocationFilterSettingsComponent;
}(BaseComponent));
export { LocationFilterSettingsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/location.filter.settings/location.filter.settings.component.ts.pre-build-optimizer.js